import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import axios from 'axios';
import { HOSTNAME } from '../../Configs/Domain';


export const listReports = createAsyncThunk(
  'reports/listReports',
  async (_, { getState }) => {
    const { reportList } = getState().reports;
    // Check if reportList already fetched to avoid duplicate requests
    if (reportList.length > 0) {
      return { reportList }; // Return the existing list if already fetched
    }
    const response = await axios.get(`${HOSTNAME}/reports/list`);
    return { reportList: response.data };
  }
);

export const loadReport = createAsyncThunk(
  'reports/loadReport',
  async ({ reportId }, { getState }) => {
    const { fetchedReports } = getState().reports;
    // Check if the report is already fetched to avoid duplicate requests
    if (fetchedReports[reportId]) {
      return fetchedReports[reportId]; // Return the existing report if already fetched
    }
    const response = await axios.get(`${HOSTNAME}/reports/load/${reportId}`);
    return { reportId, data: response.data};
  }
);

const reportsSlice = createSlice({
  name: 'reports',
  initialState: {
    reportList: [],
    fetchedReports: {},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listReports.fulfilled, (state, action) => {
        state.reportList = action.payload.reportList;
      })
      .addCase(loadReport.fulfilled, (state, action) => {
        const { reportId, data } = action.payload;
        state.fetchedReports[reportId] = data; // Store the fetched report by its ID
      });
  },
});

// Selector to get report by ID
export const selectReportById = createSelector(
  [(state, reportId) => state.reports.fetchedReports[reportId], (state, reportId) => reportId],
  (report, reportId) => report
);

export default reportsSlice.reducer;
